import { Outlet, useRouterState } from '@tanstack/react-router';
import { TabBar } from '../components/tab-bar.js';
import { Toaster } from '../components/toaster.js';
import { OfflineBanner } from '../components/offline-banner.js';
import { UpdatePrompt } from '../components/update-prompt.js';

/**
 * App shell — a centered phone-width column with a fixed bottom tab bar.
 * Each screen renders its own sticky top bar. Login owns the full column with
 * no tab bar.
 */
export function RootLayout() {
  const path = useRouterState({ select: (s) => s.location.pathname });

  if (path === '/login') {
    return (
      <div className="kd-app">
        <Outlet />
        <Toaster />
      </div>
    );
  }

  return (
    <div className="kd-app">
      <OfflineBanner />
      <div className="kd-scroll">
        <Outlet />
      </div>
      <TabBar />
      <UpdatePrompt />
      <Toaster />
    </div>
  );
}
